import React, { Fragment, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Autocomplete, CircularProgress, Grid, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";

import ApiService from "../../services/ApiService";
import { useEffect } from "react";
import { dbToDate, dbToTime } from "../../utils/dateTime";

export default function DialogAssignPic({
  dialogOpen,
  data,
  type,
  setAssignOpen,
  setFailMessage,
  setOpen3,
  setOpen2,
  setAlertOpen,
}) {
  const [search, setSearch] = useState("");
  const [user, setUser] = useState({ email: "", namalengkap: "" });
  console.log("masuk", user);
  useEffect(() => {
    setUser({ email: "", namalengkap: "" });
  }, []);

  // Action Button
  const [sendLoad, setSendLoad] = useState(false);
  const handleSend = () => {
    setSendLoad(true);

    const finalValue = {
      idLkp: data.idTblLkp,
      userPic: user.email,
      displayName: user.namalengkap,
      jabatan: user.jabatan,
    };

    ApiService.postLapInvest(finalValue)
      .then((res) => {
        if (!res.data.isOk) {
          setFailMessage(res.data.message);
          setOpen3(true);
        } else {
          setOpen2(true);
          setAlertOpen(false);
          resetValue();

          window.location.reload();
        }
      })
      .catch((err) => {
        console.log("err", err);
        setOpen3(true);
      });

    setSendLoad(false);
  };

  const handleChange = (e) => {
    setSearch(e);
  };

  const handleCloseDialog = () => {
    resetValue();
    setAssignOpen(false);
  };

  const resetValue = () => {
    setUser({ email: "", namalengkap: "" });
    setOptions([]);
  };

  const handleSearch = async () => {
    setLoading(true);

    await ApiService.getIdamanUsers(search).then((res) => {
      console.log("res.data.payload", res.data.payload);
      setOptions(res.data.payload);
    });

    setLoading(false);
  };

  // AutoComplete
  const [openN, setOpenN] = useState(false);
  const [openE, setOpenE] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  return (
    <Dialog
      open={dialogOpen}
      onClose={handleCloseDialog}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <DialogTitle
        sx={{
          bgcolor: "red",
          color: "white",
          m: 2,
          p: 2,
          textAlign: "center",
          borderRadius: "5px",
        }}
      >
        Assign PIC Laporan Investigasi
      </DialogTitle>
      <DialogContent>
        {/* 
        <TextField
          label="Find User"
          error={search.length < 5}
          fullWidth
          onKeyDown={(e) => {
            if (e.key === "Enter" && search.length >= 5) {
              handleSearch();
            }
          }}
          placeholder="Insert by name or email"
          value={search}
          onChange={handleChange}
        /> */}
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "col",
              width: "100%",
              marginBottom: "3px",
            }}
          >
            <div style={{ textAlign: "start", width: "100%" }}>
              <small>Nomor LKP : </small>
              <br />
              <span style={{ fontSize: "14px" }}>
                <b>{data.nomorLkp}</b>
              </span>
            </div>
            <div style={{ width: "100%" }}>
              <small>Waktu Kejadian :</small>
              <br />
              <span style={{ fontSize: "14px" }}>
                <b>
                  {dbToDate(data.tanggalKejadian)}{" "}
                  {dbToTime(data.tanggalKejadian)}
                </b>
              </span>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "col",
              width: "100%",
              marginBottom: "3px",
            }}
          >
            <div style={{ textAlign: "start", width: "100%" }}>
              <small>Judul : </small>
              <br />
              <span style={{ fontSize: "14px" }}>
                <b>{data.judulLaporan}</b>
              </span>
            </div>
            <div style={{ width: "100%" }}>
              <small>Kategori Insiden :</small>
              <br />
              <span style={{ fontSize: "14px" }}>
                <b>{data.tipeInsiden}</b>
              </span>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "col",
              width: "100%",
              marginBottom: "3px",
            }}
          >
            <div style={{ textAlign: "start", width: "100%" }}>
              <small>Lokasi : </small>
              <br />
              <span style={{ fontSize: "14px" }}>
                <b>{data.namaLokasi}</b>
              </span>
            </div>
            <div style={{ width: "100%" }}>
              <small>Pelaksana Investigasi :</small>
              <br />
              <span style={{ fontSize: "14px" }}>
                <b>{data.pelaksanaInvestigasi}</b>
              </span>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "col",
              width: "100%",
              marginBottom: "3px",
            }}
          >
            <div style={{ textAlign: "start", width: "100%" }}>
              <small>Region : </small>
              <br />
              <span style={{ fontSize: "14px" }}>
                <b>{data.namaRegional}</b>
              </span>
            </div>
            <div style={{ width: "100%" }}>
              <small>SLA Date :</small>
              <br />
              <span style={{ fontSize: "14px" }}>
                <b>{dbToDate(data.slaDate)}</b>
              </span>
            </div>
          </div>
        </>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <span>
              {/* <b>Nama Pegawai</b> : {user?.email ?? ""} */}
              {/* <b>Nama Pegawai</b> :{" "} */}
              <Autocomplete
                id="asynchronous-search"
                loadingText="Searching..."
                noOptionsText="No User found"
                fullWidth
                open={openN}
                onOpen={() => {
                  setOpenN(true);
                }}
                onClose={() => {
                  setOpenN(false);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && search.length >= 5) {
                    handleSearch();
                  }
                }}
                value={user}
                isOptionEqualToValue={(option, value) =>
                  option.namalengkap === value.namalengkap
                }
                getOptionLabel={(option) => option.namalengkap}
                options={options}
                loading={loading}
                onChange={(e, value) => setUser(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Nama Pegawai"
                    placeholder="Find by name"
                    onChange={(ev) => {
                      if (ev.target.value !== "" || ev.target.value !== null) {
                        handleChange(ev.target.value);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && search.length >= 5) {
                        handleSearch();
                      }
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </Fragment>
                      ),
                    }}
                  />
                )}
              />
              {/* <b>Nama Pegawai</b> : {user?.namalengkap ?? ""} */}
            </span>
          </Grid>
          <Grid item xs={12}>
            <span>
              <b>No. Pegawai</b> : {user?.nopek ?? ""}
            </span>
          </Grid>
          <Grid item xs={12}>
            <span>
              <b>Jabatan</b> : {user?.jabatan ?? ""}
            </span>
          </Grid>
          <Grid item xs={12}>
            <span>
              <b>Email Pegawai</b> : {user?.email ?? ""}
            </span>
          </Grid>
        </Grid>

        <small
          style={{
            color: search.length < 5 ? "red" : "black",
            float: "right",
            marginTop: "5px",
          }}
        >
          * Insert min. 5 characters then press enter.
        </small>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseDialog} sx={{ width: "100px", m: 1 }}>
          {type === "Create" ? "CANCEL" : "CLOSE"}
        </Button>
        {type === "Create" && (
          <LoadingButton
            onClick={handleSend}
            loading={sendLoad}
            variant="contained"
            sx={{ width: "100px", m: 1 }}
            startIcon={<SaveIcon />}
            loadingPosition="start"
            disabled={!user?.email ?? true}
          >
            SUBMIT
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
}
